<div>&nbsp;</div>
<div>
  <p-selectButton
    [options]="switchFilterStatuses"
    (onChange)="onFilter(dt)"
    [(ngModel)]="switchFilterStatus"
  ></p-selectButton>
</div>
<div>&nbsp;</div>
<p-table
  [value]="subscriberList"
  showGridlines
  #dt
  [rowHover]="false"
  [lazy]="true"
  [paginator]="true"
  [rows]="pageSize"
  (onLazyLoad)="onLoad($event)"
  [totalRecords]="totalRecords"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th>
        {{ 'label.Name' | translate }}
      </th>
      <th style="width: 14%; padding: 5px">
        <input
          pInputText
          type="text"
          placeholder="{{ 'label.Email' | translate }}"
          (input)="dt.filter($event.target.value, 'email', 'contains')"
        />
      </th>
      <th style="width: 14%">
        <p-dropdown
          [options]="websiteList"
          [style]="{ width: '100%' }"
          styleClass="ui-column-filter"
          (onChange)="dt.filter($event.value, 'originWebsite', 'equals')"
        ></p-dropdown>
      </th>
      <th style="width: 6%">
        {{ 'label.DailyDigest' | translate }}
      </th>
      <th style="width: 25%; word-wrap: break-word">
        {{ 'label.Categories' | translate }}
      </th>
      <th style="width: 12%; word-wrap: break-word">
        {{ 'label.Cities' | translate }}
      </th>
      <th style="width: 10%">
        {{ 'label.RegistrationDate' | translate }}
      </th>
      <th style="width: 8%">
        {{ 'label.Status' | translate }}
      </th>
      <th
        style="width: 5%"
        *ngIf="
          switchFilterStatus == SwitchFilterStatus.Active ||
          switchFilterStatus == SwitchFilterStatus.Pending
        "
      >
        &nbsp;
      </th>
    </tr>
  </ng-template>

  <ng-template
    pTemplate="body"
    let-subscriber
    let-expanded="expanded"
    let-columns="columns"
  >
    <tr>
      <td>
        <span>{{ subscriber.name }}</span>
      </td>
      <td>
        <span>{{ subscriber.email }}</span>
      </td>
      <td>
        <span>{{ subscriber.originWebsite.displayName }}</span>
      </td>
      <td>
        <span *ngIf="subscriber.dailyDigestOn">{{
          'label.ON' | translate
        }}</span>
        <span *ngIf="!subscriber.dailyDigestOn">{{
          'label.OFF' | translate
        }}</span>
      </td>
      <td>
        <span *ngFor="let item of subscriber.subscribedCategories">
          <span
            >{{ item?.occupationCategory?.name
            }}<span
              *ngIf="
                subscriber.subscribedCategories?.indexOf(item) !=
                subscriber.subscribedCategories?.length - 1
              "
              >;</span
            ></span
          >
        </span>
      </td>
      <td>
        <span *ngFor="let item of subscriber.subscribedLocalities">
          <span
            >{{ item?.locality?.name
            }}<span
              *ngIf="
                subscriber.subscribedLocalities?.indexOf(item) !=
                subscriber.subscribedLocalities?.length - 1
              "
              >;</span
            ></span
          >
        </span>
      </td>
      <td>
        <span>{{ subscriber.createDate | date : dateFormat }}</span>
      </td>
      <td>
        {{ SwitchFilterStatus[subscriber.subscriberStatusId] | translate }}
      </td>
      <td
        *ngIf="
          switchFilterStatus == SwitchFilterStatus.Active ||
          switchFilterStatus == SwitchFilterStatus.Pending
        "
      >
        <span>
          <a
            style="color: #2d8bce; cursor: pointer"
            (click)="onDeleteClick(subscriber)"
            >{{ 'label.Delete' | translate }}</a
          >
        </span>
      </td>
    </tr>
  </ng-template>

  <!-- <p-column field="name" title="name" header="{{'label.Name' | translate}}">
  </p-column>
  <p-column field="email" [style]="{width:'20%'}" [filter]="true" filterPlaceholder="{{'label.Email' | translate }}">
    <ng-template let-col let-subscriber="rowData" pTemplate="body">
      <span>{{subscriber[col.field]}}</span>
    </ng-template>
  </p-column>
  <p-column field="originWebsite" [style]="{'width':'10%'}" [filter]="true" >
    <ng-template pTemplate="filter" let-col>
      <p-dropdown [options]="websiteList" [style]="{'width':'100%'}" styleClass="ui-column-filter" (onChange)="dt.filter($event.value,col.field,col.filterMatchMode)"></p-dropdown>
    </ng-template>
    <ng-template let-col let-subscriber="rowData" pTemplate="body">
      <span>{{subscriber[col.field].displayName}}</span>
    </ng-template>
  </p-column>
  <p-column field="dailyDigestOn" [style]="{width:'5%'}" header="{{'label.DailyDigest' | translate}} ">
    <ng-template let-col let-subscriber="rowData" pTemplate="body">
      <span *ngIf="subscriber.dailyDigestOn">{{'label.ON'}}</span>
      <span *ngIf="!subscriber.dailyDigestOn">{{'label.OFF'}}</span>
    </ng-template>
  </p-column>
  <p-column field="subscribedCategories" [style]="{'width':'30%', 'word-wrap': 'break-word'}"header="{{'label.Categories' | translate }}">
    <ng-template let-col let-subscriber="rowData" pTemplate="body">
      <span *ngFor = "let item of subscriber.subscribedCategories">
       <span>{{item?.occupationCategory?.name}}<span *ngIf="subscriber.subscribedCategories?.indexOf(item)!= subscriber.subscribedCategories?.length-1">;</span></span>
      </span>
    </ng-template>
  </p-column>
  <p-column field="subscribedLocalities" [style]="{'word-wrap': 'break-word'}" header="{{'label.Cities' | translate}}">
    <ng-template let-col let-subscriber="rowData" pTemplate="body">
      <span *ngFor="let item of subscriber.subscribedLocalities">
        <span>{{ item?.locality?.name }}<span *ngIf="subscriber.subscribedLocalities?.indexOf(item)!= subscriber.subscribedLocalities?.length-1">;</span></span>
      </span>
    </ng-template>
  </p-column>
  <p-column field="createDate" [style]="{width:'10%'}" header="{{'label.RegistrationDate' | translate}} ">
    <ng-template let-col let-subscriber="rowData" pTemplate="body">
      <span>{{subscriber[col.field] | date: dateFormat}}</span>
    </ng-template>
  </p-column>
  <p-column field="subscriberStatusId" [style]="{width:'10%'}"header="{{'label.Status' | translate }}">
    <ng-template let-col let-subscriber="rowData" pTemplate="body">
      <span>{{SwitchFilterStatus[subscriber[col.field]] | translate}}</span>
    </ng-template>
  </p-column>
  <p-column [style]="{width:'5%'}" *ngIf ="switchFilterStatus == SwitchFilterStatus.Active || switchFilterStatus == SwitchFilterStatus.Pending">
      <ng-template  let-col let-subscriber="rowData" pTemplate="body">
        <span><a style="color:#2d8bce; cursor: pointer;"(click)="onDeleteClick(subscriber)">{{"label.Delete" | translate }}</a></span>
      </ng-template>
  </p-column> -->
</p-table>
